import React, { useEffect, useState } from "react";
import Pagination from "react-bootstrap/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort, faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";
import Banner from "../../../components/Banner";
import "../../../assets/css/LayananPublik.css";
import Apiv2 from "../../../axios/Apiv2";
import { useLocation, useParams } from "react-router-dom-v5-compat";

const InformasiSetiapSaat = (props) => {
  const [filterText, setFilterText] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [dataInformasi, setDataInformasi] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [titlePage, setTitle] = useState("-");
  const location = useLocation();
  const { link_ppid } = useParams();
  const { title, slug } = location.state || { title: 'Detail PPID', slug: link_ppid };

  const handleDownload = (d) => {
    const a = document.createElement("a");
    a.href = process.env.REACT_APP_BASE_API + "/api/v2/publik/ppid/download/" + d.id_other;
    a.download = true;
    a.rel = d.url;
    a.click();
  };

  useEffect(() => {
    Apiv2.get(`/publik/ppid?pagination=false&size=10&page=1&kategori_slug=${slug}`).then((x) => {
      setDataInformasi(x.data.data);
      setTitle(x?.data?.data[0].kategori_ppid?.nama);
    });
  }, []);

  const filteredData = dataInformasi.filter((item) =>
    item.title.toLowerCase().includes(filterText.toLowerCase())
  );

  const sortedData = filteredData.sort((a, b) => {
    if (sortDirection === "asc") {
      return a[sortColumn] < b[sortColumn] ? -1 : 1;
    } else {
      return b[sortColumn] < a[sortColumn] ? -1 : 1;
    }
  });

  const toggleSortDirection = () => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
  };

  const handleSort = (column) => {
    setSortColumn(column);
    toggleSortDirection();
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(sortedData.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <div>
        <Banner
          menu={titlePage}
          list={[
            { title: "Beranda", link: "/", active: true },
            { title: "Daftar Informasi Publik", link: "/ppid/daftar-informasi", active: true },
            { title: titlePage, link: `/ppid/daftar-informasi/${slug}`, active: false },
          ]}
          desc={"Dapatkan Informasi Publik di Dinas Pendidikan Jawa Barat."}
        />

        <div className="container mt-5">
          <input
            type="text"
            placeholder="Cari Nama"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            className="form-control mb-3"
          />
          <table className="table table-custom">
            <thead>
              <tr>
                <th onClick={() => handleSort("id")}>
                  No{" "}
                  {sortColumn === "id" && (
                    <FontAwesomeIcon icon={sortDirection === "asc" ? faSortUp : faSortDown} />
                  )}
                  {sortColumn !== "id" && <FontAwesomeIcon icon={faSort} />}
                </th>
                <th onClick={() => handleSort("nama")}>
                  Nama Dokumen{" "}
                  {sortColumn === "nama" && (
                    <FontAwesomeIcon icon={sortDirection === "asc" ? faSortUp : faSortDown} />
                  )}
                  {sortColumn !== "nama" && <FontAwesomeIcon icon={faSort} />}
                </th>
                <th onClick={() => handleSort("tahun")}>
                  Tahun{" "}
                  {sortColumn === "tahun" && (
                    <FontAwesomeIcon icon={sortDirection === "asc" ? faSortUp : faSortDown} />
                  )}
                  {sortColumn !== "tahun" && <FontAwesomeIcon icon={faSort} />}
                </th>
                <th onClick={() => handleSort("dokumen")}>
                  Aksi{" "}
                  {sortColumn === "dokumen" && (
                    <FontAwesomeIcon icon={sortDirection === "asc" ? faSortUp : faSortDown} />
                  )}
                  {sortColumn !== "dokumen" && <FontAwesomeIcon icon={faSort} />}
                </th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((data, index) => (
                <tr key={index}>
                  <td style={{ width: "80px" }}>{startIndex + index + 1}</td>
                  <td>{data.title}</td>
                  <td>{data.tahun}</td>
                  <td style={{ textAlign: "center" }}>
                    <button
                      className="btn btn-primary-custom"
                      onClick={() => handleDownload(data.file_others[0])}
                    >
                      Unduh
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination className="pagination-custom">
            <Pagination.Prev
              onClick={() => setCurrentPage((prevPage) => prevPage - 1)}
              disabled={currentPage === 1}
            />
            {pageNumbers.map((number) => (
              <Pagination.Item
                key={number}
                active={number === currentPage}
                onClick={() => setCurrentPage(number)}
              >
                {number}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => setCurrentPage((prevPage) => prevPage + 1)}
              disabled={currentPage === Math.ceil(sortedData.length / itemsPerPage)}
            />
          </Pagination>
        </div>
      </div>
    </>
  );
};

export default InformasiSetiapSaat;